import React, { useState, useEffect } from 'react'
import {
  Table,
  ButtonGroup,
  IconButton,
  Icon,
  Panel,
  Row,
  Col,
  Grid,
  Tag,
  Avatar,
  Badge,
  Button,
  ControlLabel,
  Input,
  SelectPicker,
} from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import AppContext from '../../context/AppContext'
import { useHistory } from 'react-router-dom'
import { budgetFormat } from '../../utils/formatterUtil'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'

export default function ReviewerWithdrawReviewDataTable({
  schema,
  onReload,
  pagination,
  lengthMenu,
  onSearchStatus,
  onDownload,
  onShowDetail,
  onShow,
  onChangeShow,
  onSearchReviewer,
  isApproveTable,
  statusOptions,
  statusOptionsForApprover,
}) {
  const { Column, HeaderCell, Cell } = Table
  const contextValue = React.useContext(AppContext)
  const history = useHistory()
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [status, setSatatus] = useState(isApproveTable ? 2 : 1)
  const [expanded, setExpanded] = useState(true)
  const [inputValueFirstName, setInputValueFirstName] = useState('')
  const [inputValueLastName, setInputValueLastName] = useState('')
  const [inputValueIdCard, setInputValueIdCard] = useState('')
  const [inputStatus, setInputStatus] = useState(1)
  const [dataList, setDataList] = useState([])

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  useEffect(() => {
    if(schema){
      // if(schema.values?.length > 0){
      //   let newData = schema.values.map((item, index) => {
      //     let _status = 0
      //     if(item.waitForWithdraw > 0){
      //       _status = 1
      //     }else if(item.waitForApprove > 0){
      //       _status = 2
      //     }else if(item.approved > 0){
      //       _status = 3
      //     }else if(item.sendBack > 0){
      //       _status = 4
      //     }
      //     return {status: _status, index: index ,...item}
      //   })
      //   setDataList(newData)
      // }
      setDataList(schema.values)
    }
  }, [schema])

  useEffect(() => {
    if(isApproveTable){
      setInputStatus(2)
    }
  }, [isApproveTable])

  useEffect(() => {
    setExpanded(onShow)
  }, [onShow])

  const handleChangeLength = (dataKey) => {
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, 1, inputValueFirstName, inputValueLastName, inputValueIdCard, inputStatus)
    }
  }
  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(displayLength, dataKey, inputValueFirstName, inputValueLastName, inputValueIdCard, inputStatus)
    }
  }

  const getData = () => {
    console.log('get data')
    return schema.values?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const handleChangeStatus = (sta) => {
    onSearchStatus(5, 1, sta)
  }

  const handleSearchReviewer = () => {
    onSearchReviewer(5, 1, inputValueFirstName, inputValueLastName, inputValueIdCard, inputStatus)
    setPage(1)
    setSatatus(inputStatus)
  }

  const handleCancelSearchCommittee = () => {
    setInputValueFirstName('')
    setInputValueLastName('')
    setInputValueIdCard('')
    onSearchReviewer(5, 1, '', '', '', '')
    setPage(1)
  }

  const handleOnChangeStatus = (rowData, value) => {
    let _data = [...dataList]
    _data[rowData.index].status = value
    setDataList(_data)
  }

  const getDisabledItem = (rowData) => {
    let disabled = []
    if(rowData.waitForWithdraw == 0){
      disabled.push(1)
    }
    if(rowData.waitForApprove == 0){
      disabled.push(2)
    }
    if(rowData.approved == 0){
      disabled.push(3)
    }
    if(rowData.sendBack == 0){
      disabled.push(4)
    }
    return disabled
  }
  return (
    <>
      <Panel
        header={schema.header}
        bordered
        collapsible
        defaultExpanded
        expanded={expanded}
        onSelect={() => onChangeShow()}
      >
        {schema?.searchSection && 
        <Row>
          <Col xs={24} sm={12} md={12} lg={6}>
            <ControlLabel>{schema.searchSection.firstName.label}</ControlLabel>
            <Input
              style={{ width: '100%' }}
              name={schema.searchSection.firstName.name}
              value={inputValueFirstName}
              //defaultValue={schema.searchSection.name.value}
              onChange={(value) => setInputValueFirstName(value)}
              placeHolder={schema.searchSection.firstName.hint}
            ></Input>
          </Col>
          <Col xs={24} sm={12} md={12} lg={6}>
            <ControlLabel>{schema.searchSection.lastName.label}</ControlLabel>
            <Input
              style={{ width: '100%' }}
              name={schema.searchSection.lastName.name}
              value={inputValueLastName}
              //defaultValue={schema.searchSection.lastName.value}
              onChange={(value) => setInputValueLastName(value)}
              placeHolder={schema.searchSection.lastName.hint}
            ></Input>
          </Col>
          {schema.searchSection.idCard && (
            <Col xs={24} sm={24} md={12} lg={8}>
              <ControlLabel>{schema.searchSection.idCard.label}</ControlLabel>
              <Input
                name={schema.searchSection.idCard.name}
                value={inputValueIdCard}
                //inputRef={register(isValidators(schema.searchSection.idCard.validators))}
                //placeholder={'ระบุ' + schema.searchSection.idCard.label}
                onChange={(value, e) => {
                  if (isNaN(value)) {
                    return
                  }
                  setInputValueIdCard(value)
                }}
              />
            </Col>
          )}
          <Col xs={24} sm={24} md={12} lg={4}>
          <ControlLabel>{'สถานะ'}</ControlLabel>
          <SelectPicker
              data={isApproveTable ? statusOptionsForApprover : statusOptions}
              searchable={false}
              cleanable={false}
              value={inputStatus}
              onChange={(value) => {
                //handleOnChangeStatus(rowData, value)
                setInputStatus(value)
              }}
              //disabledItemValues={getDisabledItem(rowData)}
              //style={{marginRight: 5}}
              //placeholder="ทั้งหมด"
              block
              virtualized={false}
            />
            </Col>
        </Row>}
        
        <Row>
          <div>
            <br />
            <SearchButton onClick={handleSearchReviewer}>ค้นหา</SearchButton>
            <CancelButton onClick={handleCancelSearchCommittee}>ยกเลิก</CancelButton>
          </div>
        </Row>
        <Col lg={24} md={24} sm={24} xs={24}>
          <Table
            wordWrap
            height={400}
            //data={pagination && typeof onReload !== 'function' ? getData() : schema?.values || []}
            data={dataList}
            style={{ marginTop: 5 }}
          >
            <Column width={200} fixed flexGrow={1}>
              <HeaderCell>
                <span>{schema.fullnameText}</span>
              </HeaderCell>
              <Cell>
                {(rowData) => {
                  return <span>{`${rowData.firstName} ${rowData.lastName}`}</span>
                }}
              </Cell>
            </Column>

            <Column width={110} align="center">
              <HeaderCell>
                <span>{schema.budgetYearText}</span>
              </HeaderCell>
              <Cell dataKey="budgetYear" />
            </Column>

            <Column width={88} align="center">
              <HeaderCell>
                <span>{'ประเภท'}</span>
              </HeaderCell>
              <Cell>
                {(rowData) => {
                  return <span>{rowData.isReviewOnline ? 'online' : 'กระดาษ'}</span>
                }}
              </Cell>
            </Column>

            {!isApproveTable && 
            <Column width={125} align="center">
              <HeaderCell>
                {/* <span>{schema.waitForWithdrawText}</span> */}
                รอเบิกจ่าย
              </HeaderCell>
              <Cell dataKey="waitForWithdraw" />
              {/* <TagCell dataKey="colorstatus" /> */}
            </Column>}
            
            <Column width={100} align="center">
              <HeaderCell>
                {/* <span>{schema.waitForApproveText}</span> */}
                รออนุมัติ
              </HeaderCell>
              <Cell dataKey="waitForApprove" />
            </Column>

            <Column width={100} align="center">
              <HeaderCell>
                {/* <span>{schema.approvedText}</span> */}
                อนุมัติ
              </HeaderCell>
              <Cell dataKey="approved" />
            </Column>

            {!isApproveTable && 
            <Column width={100} align="center">
              <HeaderCell>
                {/* <span>{schema.approvedText}</span> */}
                ไม่อนุมัติ
              </HeaderCell>
              <Cell dataKey="sendBack" />
            </Column>}

            {/* <Column width={100} align="center">
              <HeaderCell>
                สถานะ
              </HeaderCell>
              <Cell>
                {(rowData) => {
                  console.log(rowData)
                  return <span>{rowData.status}</span>
                }}
              </Cell>
            </Column> */}

            <Column flexGrow={1} minWidth={238}  fixed="right">
              <HeaderCell>
                <span>แสดง</span>
              </HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <Row>
                      
                      {/* <SelectPicker
                        data={isApproveTable ? statusOptionsForApprover : statusOptions}
                        searchable={false}
                        cleanable={false}
                        value={rowData.status}
                        onChange={(value) => {
                          handleOnChangeStatus(rowData, value)
                        }}
                        disabledItemValues={getDisabledItem(rowData)}
                        style={{marginRight: 5}}
                        placeholder="เลือกสถานะ"
                      /> */}
                        
                      <IconButton
                        style={{ marginRight: 5 }}
                        appearance="ghost"
                        icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                        onClick={() => {
                          onShowDetail(rowData, status)
                          setExpanded(false)
                        }}
                        //disabled={rowData.waitForWithdraw === 0}
                      >
                        แสดง
                      </IconButton>
                      {/* <IconButton
                        style={{ marginRight: 5 }}
                        appearance="ghost"
                        icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                        onClick={() => {
                          onShowDetail(rowData, 1)
                          setExpanded(false)
                        }}
                        disabled={rowData.waitForWithdraw === 0}
                      >
                        รอเบิกจ่าย
                      </IconButton>
                      <IconButton
                        style={{ marginRight: 5 }}
                        appearance="ghost"
                        icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                        onClick={() => {
                          onShowDetail(rowData, 2)
                          setExpanded(false)
                        }}
                        disabled={rowData.waitForApprove === 0}
                      >
                        รออนุมัติ
                      </IconButton>
                      <IconButton
                        style={{ marginRight: 5 }}
                        appearance="ghost"
                        icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                        onClick={() => {
                          onShowDetail(rowData, 3)
                          setExpanded(false)
                        }}
                        disabled={rowData.approved === 0}
                      >
                        อนุมัติ
                      </IconButton> */}
                      {status != 1 && (
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="download" className="bt-gost-icon-radius" />}
                          onClick={() => {
                            onDownload(rowData)
                          }}
                        >
                          ดาวน์โหลด
                        </IconButton>
                      )}
                    </Row>
                  )
                }}
              </Cell>
            </Column>
          </Table>

          {pagination && (
            <TablePagination
              lengthMenu={lengthMenu || defaultLengthMenu}
              activePage={page || defaultPage}
              renderLengthMenu={(lengthMenu) => {
                return (
                  <>
                    {lengthMenu}
                    {`รายการ/หน้า`}
                  </>
                )
              }}
              renderTotal={(total) => {
                return <>{` ทั้งหมด ${total} รายการ`}</>
              }}
              displayLength={displayLength || 5}
              total={schema.totalSize}
              onChangePage={handleChangePage}
              onChangeLength={handleChangeLength}
            />
          )}
          <br />
        </Col>
      </Panel>
    </>
  )
}

// const statusOptions = [
//   {
//     label: 'รอเบิกจ่าย',
//     value: 1
//   },
//   {
//     label: 'รออนุมัติ',
//     value: 2
//   },
//   {
//     label: 'อนุมัติ',
//     value: 3
//   },
//   {
//     label: 'ไม่อนุมัติ',
//     value: 4
//   }
// ]

// const statusOptionsForApprover = [
//   {
//     label: 'รออนุมัติ',
//     value: 2
//   },
//   {
//     label: 'อนุมัติ',
//     value: 3
//   },
// ]
